import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfettiService {
  launchCelebration(): void {
    import('canvas-confetti').then((mod) => {
      const confetti = mod.default;
      confetti({
        particleCount: 120,
        spread: 72,
        startVelocity: 35,
        ticks: 240,
        origin: { y: 0.65 },
      });
    });
  }
}
